import { Controller } from "@hotwired/stimulus"

// Aggiunge/rimuove intervalli orari nell'editor settimanale.
// Le righe nuove usano l'indice "NEW_RECORD" del template, sostituito con un
// timestamp incrementale per non collidere con le righe già presenti.
export default class extends Controller {
  static targets = ["template", "list"]

  addRow(event) {
    const weekday = event.currentTarget.dataset.weekday
    const list = this.listTargets.find((el) => el.dataset.weekday === weekday)
    const index = new Date().getTime() + this.#counter()
    const html = this.templateTarget.innerHTML
      .replaceAll("NEW_RECORD", index)
      .replaceAll("WEEKDAY_VALUE", weekday)
    list.insertAdjacentHTML("beforeend", html)
  }

  removeRow(event) {
    const row = event.currentTarget.closest("[data-booking-schedule-target='row']")
    const destroy = row.querySelector("input[name*='_destroy']")
    if (destroy && row.querySelector("input[name*='[id]']")) {
      destroy.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
  }

  #counter() {
    this.count = (this.count || 0) + 1
    return this.count
  }
}
